// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"6a02518f","1480":"012e67c2","2961":"8f8badb0","3544":"15d89236","4249":"2928ad9e","5884":"8acfea3a","6036":"15d89236","8762":"df7f57ec","9520":"ca1a0812","9790":"15d89236"}[chunkId] + ".chunk.css";
};